const SCROLL_END_TOLERANCE = 2;

function updateScrollArrows(scrollContainer, startButton, endButton) {
  if (!startButton && !endButton) return;

  const isScrollable = scrollContainer.scrollHeight - scrollContainer.clientHeight > SCROLL_END_TOLERANCE;
  const atStart = scrollContainer.scrollTop <= SCROLL_END_TOLERANCE;
  const atEnd = scrollContainer.scrollTop + scrollContainer.clientHeight >= scrollContainer.scrollHeight - SCROLL_END_TOLERANCE;

  if (startButton) startButton.hidden = !isScrollable || atStart;
  if (endButton) endButton.hidden = !isScrollable || atEnd;
}

function initThumbnailColumn(controls) {
  const startButton = controls.querySelector('[data-thumbnail-scroll="-1"]');
  const endButton = controls.querySelector('[data-thumbnail-scroll="1"]');

  const refresh = () => updateScrollArrows(controls, startButton, endButton);

  const scrollByAmount = (direction) => {
    const firstThumbnail = controls.querySelector('.slideshow-controls__thumbnail');
    const step = firstThumbnail ? firstThumbnail.getBoundingClientRect().height + 8 : controls.clientHeight * 0.8;
    controls.scrollBy({ top: direction * step * 2, behavior: 'smooth' });
  };

  startButton?.addEventListener('click', () => scrollByAmount(-1));
  endButton?.addEventListener('click', () => scrollByAmount(1));

  controls.addEventListener('scroll', refresh, { passive: true });
  new ResizeObserver(refresh).observe(controls);

  refresh();
}

function syncThumbnailHeight(gallery) {
  const container = gallery.querySelector('slideshow-component > slideshow-container');
  const controls = gallery.querySelector('slideshow-component > slideshow-controls[thumbnails]');

  if (!container || !controls) return;

  const observer = new ResizeObserver((entries) => {
    for (const entry of entries) {
      const height = entry.borderBoxSize?.[0]?.blockSize ?? entry.contentRect.height;
      controls.style.maxHeight = `${height}px`;
    }
  });

  observer.observe(container);

  initThumbnailColumn(controls);
}

function initGalleryThumbnailControls() {
  document.querySelectorAll('media-gallery.media-gallery--carousel').forEach(syncThumbnailHeight);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGalleryThumbnailControls);
} else {
  initGalleryThumbnailControls();
}

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('media-gallery.media-gallery--carousel').forEach(syncThumbnailHeight);
});
